// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_PaginaRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** One page (translation namespace) of translations-service, e.g. `Frontend`, `SOCatalog`. */
import { registerContract } from './validate'

export interface Traducoes_PaginaRow {
id?: number
nome?: string
}

registerContract('Traducoes_PaginaRow', {
  id:   { type: 'number',  required: false },
  nome: { type: 'string',  required: false },
})
